import { metaDataPageTypes } from '@/constants/types';
import { homepageMetaData } from '@/constants/message';
import {
  getCommonSEOImage,
  getDynamicMetaTitle,
  getHomePageSEOImage,
  isStringExist,
} from './string';

export const findCategoryInChildren = async (children, searchSlug) => {
  if (!children || !searchSlug) return null;

  // Search in direct children
  const directMatch = children.find((child) => child.slug === searchSlug);
  if (directMatch) {
    return {
      name: directMatch.name?.en || '',
      url: `/${directMatch.slug}`,
    };
  }

  return null;
};

export const isExistInComparisonList = (products, id) => {
  if (!Array.isArray(products) || !id) {
    return false;
  }

  return products.some((product) => product?.id === id);
};

export const prepareProductDetailSlug = (item) => {
  const mainSlug = item?.slug;
  const parentSlug = item?.parent_slug;
  const categorySlug = item?.category?.slug;

  return {
    productSlug: parentSlug || mainSlug,
    variantSlug: parentSlug ? mainSlug : null,
    categorySlug,
  };
};

export const getSpinningWheelRotationData = async ({
  totalWheelItem = 0,
  selectedIndex = null,
}) => {
  if (totalWheelItem === 0) {
    return null;
  }

  console.log({ totalWheelItem });

  const segmentAngle = totalWheelItem > 0 ? 360 / (totalWheelItem + 1) : 360; // 36 (for 10)
  const randomIndex = selectedIndex;

  // Calculate the angle for the selected segment's center
  const segmentCenter = randomIndex * segmentAngle + segmentAngle / 2;

  console.log({ segmentCenter });

  return segmentCenter;
};

export const getFormattedSeoMetaData = ({
  seoData,
  seoImage = null,
  type = metaDataPageTypes.others,
  defaultTitle = false,
}) => {
  if (type === metaDataPageTypes.home) {
    // TODO: home has title, not name.
    // for default seo title would be title not name
    return {
      title: isStringExist(seoData?.seo_title)
        ? seoData?.seo_title
        : getDynamicMetaTitle(
            seoData?.title?.en ? `${seoData?.title?.en}` : '',
          ),
      description: seoData?.seo_description || homepageMetaData.desc,
      keywords: seoData?.seo_keywords || homepageMetaData.keyWord,
      openGraph: {
        type: 'website',
        title: isStringExist(seoData?.seo_title)
          ? seoData?.seo_title
          : getDynamicMetaTitle(
              seoData?.title?.en ? `${seoData?.title?.en}` : '',
            ),
        description: seoData?.seo_description || homepageMetaData.desc,
        keywords: seoData?.seo_keywords || homepageMetaData.keyWord,
        images: getHomePageSEOImage({ imageSrc: seoImage || null }),
      },
    };
  }

  // TODO: brand, category, product has name, not title.
  // for default seo title would be name not title
  // but campaign has title not name
  return {
    title: isStringExist(seoData?.seo_title)
      ? seoData?.seo_title
      : getDynamicMetaTitle(
          defaultTitle ? seoData?.title?.en : seoData?.name?.en,
        ),
    description: seoData?.seo_description || '',
    keywords: seoData?.seo_keywords || '',
    openGraph: {
      type: 'website',
      title: isStringExist(seoData?.seo_title)
        ? seoData?.seo_title
        : getDynamicMetaTitle(
            defaultTitle ? seoData?.title?.en : seoData?.name?.en,
          ),
      description: seoData?.seo_description || '',
      keywords: seoData?.seo_keywords || '',
      images: getCommonSEOImage({ imageSrc: seoImage || null }),
    },
  };
};

export const isCtrlClickTrigger = (e) => {
  if (
    e.ctrlKey || // Windows/Linux: Ctrl + click
    e.metaKey || // Mac: Cmd + click
    e.button === 1 // Middle mouse button
  ) {
    return true;
  }
  return false;
};
